import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    loading: false,
    affiliateCustomerLoading: false,
    affiliate_users: [],
    affiliate_customers: [],
    affiliate_model: {},
    page: 1,
    page_size: 10,
    order_column: 'created_at',
    order_type: 'desc',
    dialog: false,
    dialog_model: false,
    artistPage: 1,
    artistPageSize: 10,
    affiliateArtists: {},
    labelPage: 1,
    labelPageSize: 10,
    affiliateLabels: {},
    showArtistLabelModal: false
  },

  mutations: {
    setAffiliateUsers(state, payload) {
      state.affiliate_users = payload
    },
    setAffiliateCustomers(state, payload) {
      state.affiliate_customers = payload
    },
    setAffiliateModel(state, payload) {
      state.affiliate_model = payload
    },
    setPage(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setOrdering(state, payload) {
      state.order_column = payload.column
      state.order_type = payload.type
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setAffiliateCustomerLoading(state, bool) {
      state.affiliateCustomerLoading = bool
    },
    setDialog(state, payload) {
      state.dialog = payload
    },
    setDialogModel(state, payload) {
      state.dialog_model = payload
    },
    setAffiliateArtists(state, data) {
      state.affiliateArtists = data
    },
    setArtistLabelModal(state, bool) {
      state.showArtistLabelModal = bool
    },
    setArtistPage(state, page) {
      state.artistPage = page
    },
    setArtistPageSize(state, size) {
      state.artistPageSize = size
    },
    setAffiliateLabels(state, data) {
      state.affiliateLabels = data
    },
    setLabelPage(state, page) {
      state.labelPage = page
    },
    setLabelPageSize(state, pageSize) {
      state.labelPageSize = pageSize
    }
  },

  actions: {
    readAffiliateUsers({ commit, state }) {
      commit('setLoading', true)
      axios.admin
        .get('get_affiliate_users', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type
          }
        })
        .then(r => {
          commit('setAffiliateUsers', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    readAffiliateCustomers({ commit }, payload) {
      commit('setAffiliateCustomerLoading', true)
      axios.admin
        .get(`get_affiliate_customers/${payload.user}${payload.type ? '/'+payload.type : ''}`)
        .then(r => {
          commit('setAffiliateCustomers', r.data.data)
          commit('setAffiliateCustomerLoading', false)
        })
        .catch(() => {
          commit('setAffiliateCustomerLoading', false)
        })
    },
    readAffiliateModel({ commit }, id) {
      commit('setDialogModel', true)
      axios.admin
        .get('get_affiliate_user_data/' + id)
        .then(r => {
          commit('setAffiliateModel', r.data.data)
        })
        .catch(e => {
          console.log(e)
        })
    },
    createAffiliate({ commit, dispatch }, id) {
      axios.admin.get('set_affiliate/' + id).then(() => {
        commit('setDialog', false)
        dispatch('readAffiliateUsers')
        dispatch('getAffiliatePartners', 'artist')
        dispatch('getAffiliatePartners', 'label')
      })
    },
    updateAffiliateModel({ commit, state }) {
      axios.admin
        .post('save_affiliate_user_data', {
          ...state.affiliate_model
        })
        .then(r => {
          commit('setDialogModel', false)
        })
    },
    exportCSV({ commit }, data) {
      if ('type' in data) data.user.id = data.user.user_id
      axios.admin
        .get(`affiliate_csv/${data.user.id}${'type' in data ? '/' + data.type : ''}`, {
          responseType: 'blob'
        })
        .then(r => {
          const url = window.URL.createObjectURL(new Blob([r.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute(
            'download',
            data.user.first_name + '_affiliate' + '.csv'
          )
          document.body.appendChild(link)
          link.click()
        })
        .catch(e => {
          console.log(e)
        })
    },
    getAffiliatePartners({ commit, state }, type) {
      let page, pageSize;
      if (type === 'artist'){
        page = state.artistPage;
        pageSize = state.artistPageSize;
      }
      if (type === 'label'){
        page = state.labelPage;
        pageSize = state.labelPageSize;
      }
        axios.admin.get(`affiliate/partners/${type}`, {
        params: { page: page, pageSize: pageSize }
      })
        .then(res => {
          if (type === 'artist') commit('setAffiliateArtists', res.data.partners)
          else if (type === 'label') commit('setAffiliateLabels', res.data.partners)
        })
    }
  }
}
